import React, { useEffect, useState } from "react";
import top_bg from "../../Assets/img/top_bg.png";
import logo from "../../Assets/img/logo.svg";
import { Box, Stepper, Step, StepLabel } from "@mui/material";
import ActiveStep1 from "./ActiveStep1";
import ActiveStep2 from "./ActiveStep2";
import ActiveStep3 from "./ActiveStep3";
import ActiveStep4 from "./ActiveStep4";
import ActiveStep5 from "./ActiveStep5";
import ActiveStep6 from "./ActiveStep6";
import ActiveStep8 from "./ActiveStep8";


function ParentActiveStep() {
  const isSignup=true
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    dob: '',
    personalEmail: '',
    profession: '',
    professionalEmail: '',
    phoneNo: '+' + '',
    password: '',
    image: null
  });

  const [experience, setExperience] = useState({
    companyName: "",
    Role: "",
    website: "",
    emailId: "",
    startyear: "",
    startmonth: "",
    endmonth: "present",
    endyear: "present",
    iscurrentlyworking: true,
    is_verified: false,
    logo: "",
  });

  const [education, setEducation] = useState({
    institute: "",
    institute_domain: "",
    title: "",
    eduLevel: "",
    startyear: "",
    endyear: "present",
    iscurrentlypurusing: true,
    logo: "",
  });

  const [steps, setSteps] = useState(["", "", "", ""]);

  // Use effect to append an empty string to steps when activeStep is 2
  useEffect(() => {
    if (formData?.profession === "Student" || formData?.profession === "Professional") {
      // Add the 6th step if profession is "Student" or "Professional"
      if (steps.length < 6) {
        setSteps(prevSteps => [...prevSteps, ""]);
      }
    } else {
      // Remove the 6th step if it's there and profession is not "Student" or "Professional"
      if (steps.length > 5) {
        setSteps(prevSteps => prevSteps.slice(0, 5));
      }
    }
  }, [formData?.profession]);



  // Define step1Data state and updateStep1Data function
  const [step1Data, setStep1Data] = useState({
    selectedImage: null,
    firstName: "",
    lastName: ""
  });

  // Function to update step1Data
  const updateStep1Data = (data) => {
    setStep1Data(data);
  };
  // console.log("steps", steps, "activeStep", activeStep);

  // For First Page

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  // useEffect(() => {
  //   if (formData?.profession) {
  //     if (formData.profession === "Personal") {
  //       setActiveStep(2); // directly move to email step for personal
  //       console.log(" personal active step", activeStep);
  //     } else if (formData.profession === "Student" || formData.profession === "Professional") {
  //       setActiveStep(2); // stay at profession step
  //       console.log(" professional or student active step", activeStep);
  //     } else {
  //       setActiveStep(2); // default
  //       console.log("default active step", activeStep)
  //     }
  //   }
  // }, [formData.profession]);


  const [selectedImage, setSelectedImage] = useState(null);


  const handleContinue2 = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };


  const clampedActiveStep = formData?.profession === "Personal"
    ? Math.min(activeStep, 4)
    : activeStep;

  const [ShowpasswordFirstPage, setShowpasswordFirstPage] = useState(true);


  // console.log("ACTIVE STATE", activeStep);

  // console.log("Steps count", steps.length);

  return (
    <div className="scrollable-images-container">
      <img className="header-image" src={top_bg} alt="Header" />
      <div className="onboard_header">
        <img className="logo" src={logo} alt="Logo" />
      </div>
      <div className="steps-container">
        <Box sx={{ width: "100%" }} className="stepsflow-container">
          <Stepper activeStep={clampedActiveStep} alternativeLabel className="custom-stepper">
            {steps?.map((label, index) => (

              <Step key={index}>
                <StepLabel>{label}</StepLabel>
                {index < steps?.length - 1 && <div className="step-line" />}
              </Step>
            ))}
          </Stepper>
        </Box>
      </div>
      <div className="content">
        {activeStep === 0 && (
          <React.Fragment>
            {/* <NewApp /> */}
            <ActiveStep1 setFormData={setFormData} setActiveStep={setActiveStep} step1Data={step1Data} updateStep1Data={setStep1Data} isSignup={isSignup} />
          </React.Fragment>
        )}

        {/* {activeStep === 1 && (
          <>
            {console.log("active 1 is coming")}
            <ActiveStep2
              formData={formData}
              setFormData={setFormData}
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              updateStep1Data={updateStep1Data}
              firstName={firstName}
              lastName={lastName}
              selectedImage={selectedImage}
              selectedProfession={formData.profession}
              setSteps={setSteps}
              steps={steps}
            />
          </>
        )} */}
        {activeStep === 1 && (<>
          <ActiveStep3 setFormData={setFormData} setActiveStep={setActiveStep} activeStep={activeStep} experience={experience} education={education} setSteps={setSteps} isSignup={isSignup} />
        </>)
        }
        {activeStep === 2 && (
          <>
            <ActiveStep4 setFormData={setFormData} setActiveStep={setActiveStep} activeStep={activeStep} formData={formData} isSignup={isSignup} />
          </>
        )}
        {/* {activeStep === 4 && (
          <>
            <ActiveStep6 formData={formData} setFormData={setFormData} setActiveStep={setActiveStep} activeStep={activeStep} education={education} setEducation={setEducation} experience={experience} setExperience={setExperience} />
          </>
        )} */}

        {/* Create Password */}
        {activeStep === 3 && ShowpasswordFirstPage && (
          <ActiveStep5 formData={formData} setFormData={setFormData} education={education} activeStep={activeStep} setActiveStep={setActiveStep} experience={experience} isSignup={isSignup} />
        )}
        {activeStep === 4  && (
          <ActiveStep8 setActiveStep={setActiveStep}  />
        )}
      </div>
    </div>
  );
}

export default ParentActiveStep;

// // ParentActiveStep.jsx
// import React, { useState, useEffect } from "react";
// import top_bg from "../../Assets/img/top_bg.png";
// import logo from "../../Assets/img/logo.svg";
// import { Box, Button, Stepper, Step, StepLabel, Divider, Typography } from "@mui/material";
// import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
// import ActiveStep1 from "./ActiveStep1";
// import ActiveStep3 from "./ActiveStep3";
// import ActiveStep4 from "./ActiveStep4";
// import ActiveStep5 from "./ActiveStep5";
// import ActiveStep8 from "./ActiveStep8";
// import { Link } from "react-router-dom"; // Add this import if using React Router

// function ParentActiveStep() {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     dob: '',
//     personalEmail: '',
//     profession: 'Personal',
//     professionalEmail: '',
//     phoneNo: '+' + '',
//     password: '',
//     image: null
//   });

//   const [experience, setExperience] = useState({
//     companyName: "",
//     Role: "",
//     website: "",
//     emailId: "",
//     startyear: "",
//     startmonth: "",
//     endmonth: "present",
//     endyear: "present",
//     iscurrentlyworking: true,
//     is_verified: false,
//     logo: "",
//   });

//   const [education, setEducation] = useState({
//     institute: "",
//     institute_domain: "",
//     title: "",
//     eduLevel: "",
//     startyear: "",
//     endyear: "present",
//     iscurrentlypurusing: true,
//     logo: "",
//   });

//   const [step1Data, setStep1Data] = useState({
//     selectedImage: null,
//     firstName: "",
//     lastName: ""
//   });

//   const updateStep1Data = (data) => {
//     setStep1Data(data);
//   };

//   // Track completed sections
//   const [completedSections, setCompletedSections] = useState({
//     profile: false,
//     email: false,
//     phone: false,
//     password: false,
//     resume: false
//   });

//   const updateFormData = (newData) => {
//     setFormData(prev => ({ ...prev, ...newData }));
//   };

//   // Scroll to top of section
//   const scrollToSection = (sectionId) => {
//     const element = document.getElementById(sectionId);
//     if (element) {
//       element.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   };

//   // Section completion statuses
//   const isProfileComplete = () => {
//     return formData.firstName?.trim() && 
//            formData.lastName?.trim() && 
//            formData.dob;
//   };

//   const isEmailComplete = () => {
//     return formData.personalEmail && 
//            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.personalEmail);
//   };

//   const isPhoneComplete = () => {
//     return formData.phoneNo && formData.phoneNo.length > 5;
//   };

//   const isPasswordComplete = () => {
//     return formData.password && 
//            formData.password.length >= 8 &&
//            formData.password === formData.confirmPassword;
//   };

//   // Update completed sections
//   useEffect(() => {
//     setCompletedSections({
//       profile: isProfileComplete(),
//       email: isEmailComplete(),
//       phone: isPhoneComplete(),
//       password: isPasswordComplete(),
//       resume: false // Optional
//     });
//   }, [formData]);

//   const steps = ["Profile", "Email", "Phone", "Password", "Resume"];

//   return (
//     <div className="scrollable-images-container">
//       <img className="header-image" src={top_bg} alt="Header" />
//       <div className="onboard_header">
//         <img className="logo" src={logo} alt="Logo" />
//       </div>

//       {/* Welcome Section - Centered */}
//       <Box sx={{ 
//         maxWidth: 720, 
//         mx: 'auto', 
//         px: { xs: 2, sm: 3, md: 4 }, 
//         pt: 2,
//         pb: 1,
//         textAlign: 'center' // Added to center the content
//       }}>
//         <h2 className="onboard-slide-title" style={{fontSize:"32px",  textAlign: 'center', marginBottom: '8px' }}>
//           Hi, Welcome to Neoin!
//         </h2>
        
//         {/* Already have account? Login link */}
//         <Typography 
//           variant="body2" 
//           sx={{ 
//             color: '#475569', 
//             fontSize: '1.2rem',
//             marginBottom: '16px',
//             textAlign: 'center'
//           }}
//         >
//           Already have an account?{' '}
//           <Link 
//             to="/login" 
//             style={{ 
//               color: '#0044C6', 
//               fontWeight: 600,
//               textDecoration: 'none',
//               '&:hover': {
//                 textDecoration: 'underline'
//               }
//             }}
//           >
//             Login
//           </Link>
//         </Typography>

//         {/* Progress Indicator */}
//         <Box sx={{ 
//           maxWidth: 720, 
//           mx: 'auto', 
//           px: { xs: 2, sm: 3, md: 4 }, 
//           pt: 2,
//           pb: 1
//         }}>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mr:"10px" }}>
//               Complete Your Profile 
//             </Typography>
//             <Typography sx={{ color: '#475569', fontSize: '0.85rem' }}>
//               {Object.values(completedSections).filter(Boolean).length} of {steps.length} completed
//             </Typography>
//           </Box>
          
//           {/* Progress Bar */}
//           <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
//             {steps.map((label, index) => {
//               const isComplete = completedSections[['profile', 'email', 'phone', 'password', 'resume'][index]];
//               return (
//                 <Box
//                   key={index}
//                   onClick={() => scrollToSection(`section-${index}`)}
//                   sx={{
//                     flex: 1,
//                     height: 4,
//                     borderRadius: 2,
//                     bgcolor: isComplete ? '#0044C6' : '#e0e0e0',
//                     cursor: 'pointer',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       opacity: 0.8,
//                     }
//                   }}
//                 />
//               );
//             })}
//           </Box>
//         </Box>
//       </Box>

//       {/* All Steps in One Scrollable Page */}
//       <Box sx={{ maxWidth: 720, mx: 'auto', px: { xs: 2, sm: 3, md: 4 }, py: 2 }}>
//         {/* Step 1: Profile */}
//         <Box id="section-0" sx={{ mb: 4 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//             <Box sx={{ 
//               width: 32, 
//               height: 32, 
//               borderRadius: '50%', 
//               bgcolor: completedSections.profile ? '#0044C6' : '#e0e0e0',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: completedSections.profile ? '#fff' : '#999',
//               fontWeight: 600,
//               fontSize: '0.85rem'
//             }}>
//               {completedSections.profile ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '1'}
//             </Box>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
//               Profile Information
//             </Typography>
//             {completedSections.profile && (
//               <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
//                 ✓ Complete
//               </Typography>
//             )}
//           </Box>
          
//           <Box sx={{ 
//             p: { xs: 2, sm: 3 }, 
//             bgcolor: '#f8fbff', 
//             borderRadius: 3,
//             border: '1px solid rgba(0,68,198,0.08)',
//           }}>
//             <ActiveStep1 
//               setFormData={setFormData} 
//               setActiveStep={() => scrollToSection('section-1')}
//               step1Data={step1Data} 
//               updateStep1Data={updateStep1Data} 
//             />
//           </Box>
//         </Box>

//         <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

//         {/* Step 2: Email */}
//         <Box id="section-1" sx={{ mb: 4 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//             <Box sx={{ 
//               width: 32, 
//               height: 32, 
//               borderRadius: '50%', 
//               bgcolor: completedSections.email ? '#0044C6' : '#e0e0e0',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: completedSections.email ? '#fff' : '#999',
//               fontWeight: 600,
//               fontSize: '0.85rem'
//             }}>
//               {completedSections.email ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '2'}
//             </Box>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
//               Email Verification
//             </Typography>
//             {completedSections.email && (
//               <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
//                 ✓ Verified
//               </Typography>
//             )}
//           </Box>
          
//           <Box sx={{ 
//             p: { xs: 2, sm: 3 }, 
//             bgcolor: '#f8fbff', 
//             borderRadius: 3,
//             border: '1px solid rgba(0,68,198,0.08)'
//           }}>
//             <ActiveStep3 
//               setFormData={setFormData} 
//               setActiveStep={() => scrollToSection('section-2')}
//               activeStep={2} 
//               experience={experience} 
//               education={education} 
//             />
//           </Box>
//         </Box>

//         <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

//         {/* Step 3: Phone */}
//         <Box id="section-2" sx={{ mb: 4 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//             <Box sx={{ 
//               width: 32, 
//               height: 32, 
//               borderRadius: '50%', 
//               bgcolor: completedSections.phone ? '#0044C6' : '#e0e0e0',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: completedSections.phone ? '#fff' : '#999',
//               fontWeight: 600,
//               fontSize: '0.85rem'
//             }}>
//               {completedSections.phone ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '3'}
//             </Box>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
//               Phone Verification
//             </Typography>
//             {completedSections.phone && (
//               <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
//                 ✓ Verified
//               </Typography>
//             )}
//           </Box>
          
//           <Box sx={{ 
//             p: { xs: 2, sm: 3 }, 
//             bgcolor: '#f8fbff', 
//             borderRadius: 3,
//             border: '1px solid rgba(0,68,198,0.08)'
//           }}>
//             <ActiveStep4 
//               setFormData={setFormData} 
//               setActiveStep={() => scrollToSection('section-3')}
//               activeStep={3} 
//               formData={formData} 
//             />
//           </Box>
//         </Box>

//         <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

//         {/* Step 4: Password */}
//         <Box id="section-3" sx={{ mb: 4 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//             <Box sx={{ 
//               width: 32, 
//               height: 32, 
//               borderRadius: '50%', 
//               bgcolor: completedSections.password ? '#0044C6' : '#e0e0e0',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: completedSections.password ? '#fff' : '#999',
//               fontWeight: 600,
//               fontSize: '0.85rem'
//             }}>
//               {completedSections.password ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '4'}
//             </Box>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
//               Create Password
//             </Typography>
//             {completedSections.password && (
//               <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
//                 ✓ Complete
//               </Typography>
//             )}
//           </Box>
          
//           <Box sx={{ 
//             p: { xs: 2, sm: 3 }, 
//             bgcolor: '#f8fbff', 
//             borderRadius: 3,
//             border: '1px solid rgba(0,68,198,0.08)'
//           }}>
//             <ActiveStep5 
//               formData={formData} 
//               setFormData={setFormData} 
//               education={education} 
//               activeStep={4} 
//               setActiveStep={() => scrollToSection('section-4')} 
//               experience={experience} 
//             />
//           </Box>
//         </Box>

//         <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

//         {/* Step 5: Resume */}
//         <Box id="section-4" sx={{ mb: 4 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//             <Box sx={{ 
//               width: 32, 
//               height: 32, 
//               borderRadius: '50%', 
//               bgcolor: '#e0e0e0',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: '#999',
//               fontWeight: 600,
//               fontSize: '0.85rem'
//             }}>
//               5
//             </Box>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
//               Resume Upload
//             </Typography>
//             <Typography sx={{ color: '#999', fontSize: '0.75rem', ml: 'auto' }}>
//               Optional
//             </Typography>
//           </Box>
          
//           <Box sx={{ 
//             p: { xs: 2, sm: 3 }, 
//             bgcolor: '#f8fbff', 
//             borderRadius: 3,
//             border: '1px solid rgba(0,68,198,0.08)'
//           }}>
//             <ActiveStep8 
//               setActiveStep={() => {}} 
//             />
//           </Box>
//         </Box>

//       </Box>
//     </div>
//   );
// }

// export default ParentActiveStep;




// ParentActiveStep.jsx
// import React, { useState, useEffect } from "react";
// import top_bg from "../../Assets/img/top_bg.png";
// import logo from "../../Assets/img/logo.svg";
// import { Box, Button, Stepper, Step, StepLabel, Divider, Typography } from "@mui/material";
// import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
// import ActiveStep1 from "./ActiveStep1";
// import ActiveStep3 from "./ActiveStep3";
// import ActiveStep4 from "./ActiveStep4";
// import ActiveStep5 from "./ActiveStep5";
// import ActiveStep8 from "./ActiveStep8";
// import { Link } from "react-router-dom";

// function ParentActiveStep() {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     dob: '',
//     personalEmail: '',
//     profession: 'Personal',
//     professionalEmail: '',
//     phoneNo: '+' + '',
//     password: '',
//     confirmPassword: '', // Added confirmPassword
//     image: null
//   });

//   const [experience, setExperience] = useState({
//     companyName: "",
//     Role: "",
//     website: "",
//     emailId: "",
//     startyear: "",
//     startmonth: "",
//     endmonth: "present",
//     endyear: "present",
//     iscurrentlyworking: true,
//     is_verified: false,
//     logo: "",
//   });

//   const [education, setEducation] = useState({
//     institute: "",
//     institute_domain: "",
//     title: "",
//     eduLevel: "",
//     startyear: "",
//     endyear: "present",
//     iscurrentlypurusing: true,
//     logo: "",
//   });

//   const [step1Data, setStep1Data] = useState({
//     selectedImage: null,
//     firstName: "",
//     lastName: ""
//   });

//   const updateStep1Data = (data) => {
//     setStep1Data(data);
//   };

//   // Track verification status for email and phone
//   const [verificationStatus, setVerificationStatus] = useState({
//     emailVerified: false,
//     phoneVerified: false,
//     emailOtpSent: false,
//     phoneOtpSent: false
//   });

//   // Track completed sections (separate from verification)
//   const [completedSections, setCompletedSections] = useState({
//     profile: false,
//     email: false,
//     phone: false,
//     password: false,
//     resume: false
//   });

//   const updateFormData = (newData) => {
//     setFormData(prev => ({ ...prev, ...newData }));
//   };

//   // Scroll to top of section
//   const scrollToSection = (sectionId) => {
//     const element = document.getElementById(sectionId);
//     if (element) {
//       element.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   };

//   // Section completion statuses
//   const isProfileComplete = () => {
//     return formData.firstName?.trim() && 
//            formData.lastName?.trim() && 
//            formData.dob;
//   };

//   const isEmailComplete = () => {
//     return formData.personalEmail && 
//            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.personalEmail);
//   };

//   const isPhoneComplete = () => {
//     return formData.phoneNo && formData.phoneNo.length > 5;
//   };

//   const isPasswordComplete = () => {
//     return formData.password && 
//            formData.password.length >= 8 &&
//            formData.password === formData.confirmPassword;
//   };

//   // Update completed sections and verification status
//   useEffect(() => {
//     setCompletedSections({
//       profile: isProfileComplete(),
//       email: isEmailComplete() && verificationStatus.emailVerified, // Only complete if verified
//       phone: isPhoneComplete() && verificationStatus.phoneVerified, // Only complete if verified
//       password: isPasswordComplete(),
//       resume: false
//     });
//   }, [formData, verificationStatus]);

//   // Handler for email verification
//   const handleEmailVerification = (status) => {
//     setVerificationStatus(prev => ({
//       ...prev,
//       emailVerified: status
//     }));
//   };

//   // Handler for phone verification
//   const handlePhoneVerification = (status) => {
//     setVerificationStatus(prev => ({
//       ...prev,
//       phoneVerified: status
//     }));
//   };

//   const steps = ["Profile", "Email", "Phone", "Password", "Resume"];

//   return (
//     <div className="scrollable-images-container">
//       <img className="header-image" src={top_bg} alt="Header" />
//       <div className="onboard_header">
//         <img className="logo" src={logo} alt="Logo" />
//       </div>

//       {/* Welcome Section - Centered */}
//       <Box sx={{ 
//         maxWidth: 720, 
//         mx: 'auto', 
//         px: { xs: 2, sm: 3, md: 4 }, 
//         pt: 2,
//         pb: 1,
//         textAlign: 'center'
//       }}>
//         <h2 className="onboard-slide-title" style={{fontSize:"32px",  textAlign: 'center', marginBottom: '8px' }}>
//           Hi, Welcome to Neoin!
//         </h2>
        
//         <Typography 
//           variant="body2" 
//           sx={{ 
//             color: '#475569', 
//             fontSize: '1.2rem',
//             marginBottom: '16px',
//             textAlign: 'center'
//           }}
//         >
//           Already have an account?{' '}
//           <Link 
//             to="/login" 
//             style={{ 
//               color: '#0044C6', 
//               fontWeight: 600,
//               textDecoration: 'none',
//               '&:hover': {
//                 textDecoration: 'underline'
//               }
//             }}
//           >
//             Login
//           </Link>
//         </Typography>

//         {/* Progress Indicator */}
//         <Box sx={{ 
//           maxWidth: 720, 
//           mx: 'auto', 
//           px: { xs: 2, sm: 3, md: 4 }, 
//           pt: 2,
//           pb: 1
//         }}>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mr:"10px" }}>
//               Complete Your Profile 
//             </Typography>
//             <Typography sx={{ color: '#475569', fontSize: '0.85rem' }}>
//               {Object.values(completedSections).filter(Boolean).length} of {steps.length} completed
//             </Typography>
//           </Box>
          
//           {/* Progress Bar */}
//           <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
//             {steps.map((label, index) => {
//               const isComplete = completedSections[['profile', 'email', 'phone', 'password', 'resume'][index]];
//               return (
//                 <Box
//                   key={index}
//                   onClick={() => scrollToSection(`section-${index}`)}
//                   sx={{
//                     flex: 1,
//                     height: 4,
//                     borderRadius: 2,
//                     bgcolor: isComplete ? '#0044C6' : '#e0e0e0',
//                     cursor: 'pointer',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       opacity: 0.8,
//                     }
//                   }}
//                 />
//               );
//             })}
//           </Box>
//         </Box>
//       </Box>

//       {/* All Steps in One Scrollable Page */}
//       <Box sx={{ maxWidth: 720, mx: 'auto', px: { xs: 2, sm: 3, md: 4 }, py: 2 }}>
//         {/* Step 1: Profile */}
//         <Box id="section-0" sx={{ mb: 4 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//             <Box sx={{ 
//               width: 32, 
//               height: 32, 
//               borderRadius: '50%', 
//               bgcolor: completedSections.profile ? '#0044C6' : '#e0e0e0',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: completedSections.profile ? '#fff' : '#999',
//               fontWeight: 600,
//               fontSize: '0.85rem'
//             }}>
//               {completedSections.profile ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '1'}
//             </Box>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
//               Profile Information
//             </Typography>
//             {completedSections.profile && (
//               <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
//                 ✓ Complete
//               </Typography>
//             )}
//           </Box>
          
//           <Box sx={{ 
//             p: { xs: 2, sm: 3 }, 
//             bgcolor: '#f8fbff', 
//             borderRadius: 3,
//             border: '1px solid rgba(0,68,198,0.08)',
//           }}>
//             <ActiveStep1 
//               setFormData={setFormData} 
//               setActiveStep={() => scrollToSection('section-1')}
//               step1Data={step1Data} 
//               updateStep1Data={updateStep1Data} 
//             />
//           </Box>
//         </Box>

//         <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

//         {/* Step 2: Email */}
//         <Box id="section-1" sx={{ mb: 4 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//             <Box sx={{ 
//               width: 32, 
//               height: 32, 
//               borderRadius: '50%', 
//               bgcolor: verificationStatus.emailVerified ? '#0044C6' : '#e0e0e0',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: verificationStatus.emailVerified ? '#fff' : '#999',
//               fontWeight: 600,
//               fontSize: '0.85rem'
//             }}>
//               {verificationStatus.emailVerified ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '2'}
//             </Box>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
//               Email Verification
//             </Typography>
//             {verificationStatus.emailVerified ? (
//               <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
//                 ✓ Verified
//               </Typography>
//             ) : isEmailComplete() && (
//               <Typography sx={{ color: '#ff9800', fontSize: '0.75rem', ml: 'auto' }}>
//                 ⚠️ Verify OTP
//               </Typography>
//             )}
//           </Box>
          
//           <Box sx={{ 
//             p: { xs: 2, sm: 3 }, 
//             bgcolor: '#f8fbff', 
//             borderRadius: 3,
//             border: '1px solid rgba(0,68,198,0.08)'
//           }}>
//             <ActiveStep3 
//               setFormData={setFormData} 
//               setActiveStep={() => scrollToSection('section-2')}
//               activeStep={2} 
//               experience={experience} 
//               education={education}
//               onVerificationComplete={handleEmailVerification}
//               verificationStatus={verificationStatus}
//             />
//           </Box>
//         </Box>

//         <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

//         {/* Step 3: Phone */}
//         <Box id="section-2" sx={{ mb: 4 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//             <Box sx={{ 
//               width: 32, 
//               height: 32, 
//               borderRadius: '50%', 
//               bgcolor: verificationStatus.phoneVerified ? '#0044C6' : '#e0e0e0',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: verificationStatus.phoneVerified ? '#fff' : '#999',
//               fontWeight: 600,
//               fontSize: '0.85rem'
//             }}>
//               {verificationStatus.phoneVerified ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '3'}
//             </Box>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
//               Phone Verification
//             </Typography>
//             {verificationStatus.phoneVerified ? (
//               <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
//                 ✓ Verified
//               </Typography>
//             ) : isPhoneComplete() && (
//               <Typography sx={{ color: '#ff9800', fontSize: '0.75rem', ml: 'auto' }}>
//                 ⚠️ Verify OTP
//               </Typography>
//             )}
//           </Box>
          
//           <Box sx={{ 
//             p: { xs: 2, sm: 3 }, 
//             bgcolor: '#f8fbff', 
//             borderRadius: 3,
//             border: '1px solid rgba(0,68,198,0.08)'
//           }}>
//             <ActiveStep4 
//               setFormData={setFormData} 
//               setActiveStep={() => scrollToSection('section-3')}
//               activeStep={3} 
//               formData={formData}
//               onVerificationComplete={handlePhoneVerification}
//               verificationStatus={verificationStatus}
//             />
//           </Box>
//         </Box>

//         <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

//         {/* Step 4: Password */}
//         <Box id="section-3" sx={{ mb: 4 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//             <Box sx={{ 
//               width: 32, 
//               height: 32, 
//               borderRadius: '50%', 
//               bgcolor: completedSections.password ? '#0044C6' : '#e0e0e0',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: completedSections.password ? '#fff' : '#999',
//               fontWeight: 600,
//               fontSize: '0.85rem'
//             }}>
//               {completedSections.password ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '4'}
//             </Box>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
//               Create Password
//             </Typography>
//             {completedSections.password && (
//               <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
//                 ✓ Complete
//               </Typography>
//             )}
//           </Box>
          
//           <Box sx={{ 
//             p: { xs: 2, sm: 3 }, 
//             bgcolor: '#f8fbff', 
//             borderRadius: 3,
//             border: '1px solid rgba(0,68,198,0.08)'
//           }}>
//             <ActiveStep5 
//               formData={formData} 
//               setFormData={setFormData} 
//               education={education} 
//               activeStep={4} 
//               setActiveStep={() => scrollToSection('section-4')} 
//               experience={experience} 
//             />
//           </Box>
//         </Box>

//         <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

//         {/* Step 5: Resume */}
//         <Box id="section-4" sx={{ mb: 4 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//             <Box sx={{ 
//               width: 32, 
//               height: 32, 
//               borderRadius: '50%', 
//               bgcolor: '#e0e0e0',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: '#999',
//               fontWeight: 600,
//               fontSize: '0.85rem'
//             }}>
//               5
//             </Box>
//             <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
//               Resume Upload
//             </Typography>
//             <Typography sx={{ color: '#999', fontSize: '0.75rem', ml: 'auto' }}>
//               Optional
//             </Typography>
//           </Box>
          
//           <Box sx={{ 
//             p: { xs: 2, sm: 3 }, 
//             bgcolor: '#f8fbff', 
//             borderRadius: 3,
//             border: '1px solid rgba(0,68,198,0.08)'
//           }}>
//             <ActiveStep8 
//               setActiveStep={() => {}} 
//             />
//           </Box>
//         </Box>

//       </Box>
//     </div>
//   );
// }

// export default ParentActiveStep;



